import {CancelToken} from 'axios';

import {apiClient} from 'core/apiClient';
import {Cluster, ClusterFilterDictionaries, ClustersRequest} from 'types/geo';

const path = '/epcis-event/geography/clusters';
export async function getClusters(params: ClustersRequest, cancelToken?: CancelToken) {
    return (
        await apiClient.get<Cluster[]>(path, {
            params,
            headers: {'Customer-Timezone': '0'},
            cancelToken,
        })
    ).data;
}
export async function getClusterFilters(cancelToken?: CancelToken) {
    return (await apiClient.get<ClusterFilterDictionaries>(path + '/filters', {cancelToken})).data;
}
